//This is currently just a placeholder component to satisfy the FieldFragment type
// used in Field.tsx. Thi is just a temporary fix. We added a new question type in `create`
// for a MultiGridChoiceField for the new CARE brief, however, this component doesn't
// exist on 99d yet so for now we're just adding this placeholder until we have sorted it out
import { MultiGridChoiceFieldFragment } from './MultiGridChoiceField.generated';

export type Props = MultiGridChoiceFieldFragment;

export function Edit({ id: label, subtext, options, required }: Props) {
    return <div />;
}

export function View({ multiGridChoiceValue: values, options }: Props) {
    return <div />;
}

export function HasValue({ multiGridChoiceValue }: Props): boolean {
    return false;
}

export function getValue({ multiGridChoiceValue }: Props) {
    return <div />;
}
